import { Component, Input } from '@angular/core';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { ISectionData, RowTypes } from '../../../../public-api';
import { IFinancialTableData } from '../../../interfaces/pdf-tron/financial-table-data.interface';

@Component({
    selector: 'aumico-annualReport-appropriation-of-profit-german-display-component',
    templateUrl: 'appropriation-german-display.component.html',
    styleUrls: ['appropriation-german-display.component.scss'],
})
export class AppropriationOfProfitGermanDisplayComponent {
    textColor: string;
    backgroundColor: string;
    backgroundColorPY: string;
    tableFooterColor: string;
    tableHeaderColor: string;
    description: string;
    ccrFootnote: string | null = null;
    @Input() set stylePreferenceOptions(value: IStyleOptions) {
        if (value != null) {
            this.textColor = value.textColor;
            this.backgroundColor = value.backgroundColor;
            this.tableHeaderColor = value.tableHeaderColor;
            this.tableFooterColor = value.tableFooterColor;
            this.backgroundColorPY = value.backgroundColorPY;
        }
    }

    @Input() noPreviousData = false;

    @Input() isSnapshot = false;

    sectionData: IFinancialTableData[][];
    ccrSectionData: IFinancialTableData[] | null = null;

    @Input() set appropriationOfProfitSection(section: ISectionData) {
        if (!section) return;

        // Parse section.data (flat array) into per-table buckets by splitting on TABLE_HEAD,
        // exactly like the original code — this is always populated by the mapper.
        const allTables: IFinancialTableData[][] = [];
        let current: IFinancialTableData[] | null = null;

        for (const item of section.data as IFinancialTableData[]) {
            if (item.rowType === RowTypes.TABLE_HEAD) {
                current = [item];
                allTables.push(current);
            } else if (current) {
                current.push(item);
            }
        }

        // First two tables are profit-calculation and proposal (always present).
        // The third table, when present, is the CCR table.
        this.sectionData = allTables.slice(0, 2);
        this.ccrSectionData = allTables.length > 2 ? allTables[2] : null;

        this.description = section.description;
        this.ccrFootnote = section.ccrFootnote ?? null;
    }
}
